module.exports = __webpack_public_path__ + "static/media/new.bb8795ab.png";